var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M12 19.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M10.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M12 2v3m-7 7H2m10 7v3m7-10h3"
  }));
}
export default SvgIconTarget;